<template>
  <div class="home-page">
    <Header></Header>
    <div class="chances-top disflex crfff ac">
      <div @click="back">
        <img class="nav-icon-left" src="../../static/images/back.png" width="20"/>
        <div>{{ $t('Back') }}</div>
      </div>
    </div>
    <div class="mission-content ac crfff">
      <div class="fs50 mt50">{{productDetail.title}}</div>
      <div class="css-1asaykn mt50">
        <!-- 视频播放区域 -->
        <div  class="video-player-wrap mt30">
          <video
            ref="videoPlayer"
            class="video-player"
            :src="productDetail.video_path"
            controls
            playsinline
            webkit-playsinline
            preload="auto"
            :poster="productDetail.image"
            muted
            loop
          ></video>
        </div>

        <!-- 上传照片 -->
        <div class="upload-row mt30">
          <label class="pick-photo-btn">
            <input accept="image/*" type="file" class="hidden-input" @change="convertToBase64_v2">
            <img class="pick-photo-icon" src="../../static/images/transparent.png" alt="" />
            <span>{{ $t('Upload') }}</span>
          </label>
          <div v-if="imageBase64" class="thumb-preview">
            <img :src="imageBase64" alt="preview" />
          </div>
        </div>
        <!-- 生成按钮 -->
        <div class="generate-row mt20">
          <button class="button" @click="uploadImage">
            <strong>{{ $t('Generate') }}</strong>
          </button>
        </div>

        <div class="chances-row mt20">
          <button class="btn btn-blue">{{$t('ChancesLeft')}} : {{score}}</button>
<!--          <button class="button fs12 ml10" @click="goPurchaseChances"><strong>{{ $t('BuyChances') }}</strong><img-->
<!--            src="../../static/images/buy.png" style="margin-left: 0.1rem;width: 0.25rem" ></button>-->
        </div>
      </div>
    </div>
    <Dialog ref="imgDialog" :iscloseMask="true" :modalFoot="false" style="min-height: 300px;" title="" type="alert"
            width="100">
      <div slot="mdBox" class="alert-modal">
        <div class="close" style="text-align: right;margin: 0 auto;font-size: 50px;" @click="closeTmgDialog">×</div>
        <div v-if="imageShow" class="image ac">
          <div class="" style="font-size:0.3rem;margin-bottom: 20px;">{{ $t('downTips1') }}</div>
          <img v-if="isShowResult==1" :src="detail.url" style="width:80%;"/>
          <img v-if="isShowResult==2" :src="detail.original_url" style="width:80%;"/>

          <div class="tab mt50">
            <span :class="{'active':isShowResult==1}" @click="getResult(1)">{{ $t('Result') }}</span>
            <span :class="{'active':isShowResult==2}" @click="getResult(2)">{{ $t('Original') }}</span>
          </div>
          <div class="img-tools">
            <div class="ac disflex mt30">
              <div class="input-item">
                <div v-if="isShowResult==1" class="input-item2">
                  <input v-model="detail.url" class="input" disabled placeholder="" type="">
                  <img v-if="detail.url" id="copycode" :data-clipboard-text="detail.url"
                       src="../../static/images/Copy.png" style="margin-left: 10px;width: 1rem" @click="copy"/>
                </div>
                <div v-if="isShowResult==2" class="input-item2">
                  <input v-model="detail.original_url" class="input" disabled placeholder="" type="">
                  <img v-if="detail.original_url" id="copycode" :data-clipboard-text="detail.original_url"
                       src="../../static/images/Copy.png" style="margin-left: 10px;width: 1rem" @click="copy"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>


    <Dialog ref="processDialog" :iscloseMask="true" :modalFoot="false" style="min-height: 300px;" title="" type="alert"
            width="100">
      <div slot="mdBox" class="alert-modal ac">
        <div class="fs33 mt50 ac">{{ processMsg }}</div>
        <button class="button mt30" @click="closeProcessDialog">{{ $t('OK') }}</button>
      </div>
    </Dialog>

  </div>
</template>
<script>
import Header from '../components/Header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'

export default {
  components: {
    Header, Dialog
  },
  data() {

    return {
      detail: {},
      isShow: false,
      value: 50,
      imageShow: false,
      imageBase64: null,
      imageTpye: '',
      withScratch: false,
      isImgModel: false,
      isImage: true,
      score: 0,
      isShowResult: 1,
      processMsg: "",
      isType: '',
      productId:0,
      productDetail:{},
    }
  },
  watch: {},
  computed: {},
  mounted() {
    let that = this;
  },
  created() {
    if (this.$route.query.id) {
      this.productId = this.$route.query.id
      this.getProductInfo()
    }
    this.getHome();
  },
  methods: {
    getClick(item) {
      this.isType = item.key
    },
    getResult(type) {
      this.isShowResult = type
    },
    copy(item) {
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    back() {
      this.$router.go(-1);
    },
    getHome() {
      let that = this;
      that.$api.get('/api/user/info', null, r => {
        that.$parent.returnCode(r, function () {
          that.score = r.data.score
        });
      })
    },
    getProductInfo(){
      let that = this;
      let data = {'id': that.productId}
      that.$api.post('/api/product/detail', data, r => {
        that.$parent.returnCode(r, function () {
          that.productDetail = r.data
          that.autoPlayVideo()
        });
      })
    },
    autoPlayVideo() {
      this.$nextTick(() => {
        let video = this.$refs.videoPlayer
        if (video) {
          video.play().catch(() => {})
        }
      })
    },

    getCharactersAfter(str, charToFind) {
      var index = str.indexOf(charToFind);
      if (index !== -1) {
        return str.slice(index + 1);
      }
      return ''; // 如果字符未找到，返回空字符串
    },
    convertToBase64(event) {
      const file = event.target.files[0];
      this.imageTpye = this.getCharactersAfter(file.type, '/');
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageBase64 = e.target.result;
          // 在这里可以将Base64字符串上传到服务器
          // this.uploadImage(this.imageBase64);
        };
        reader.readAsDataURL(file);
      }
    },
    convertToBase64_v2(event) {
      let that = this;
      const file = event.target.files[0];
      if (!file) return;
      // 原始大小（单位：KB）
      const originSizeKB = (file.size / 1024).toFixed(2);
      console.log("原始文件大小:", originSizeKB, "KB");
      // 1. 文件大小限制（5MB）
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        that.$refs.processDialog.showMaskFun();
        that.processMsg = this.$t('pic_size_limit')
        event.target.value = '';
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          // 2. 缩放尺寸
          const maxWidth = 800;
          const maxHeight = 800;
          let {width, height} = img;
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          // 3. PNG 自动转 JPEG
          let outputType = file.type.toLowerCase() === 'image/png' ? 'image/jpeg' : file.type;
          // 4. 压缩导出（JPEG 质量 0.7）
          this.imageBase64 = canvas.toDataURL(outputType, 0.7);
          // 5. 设置上传类型
          this.imageTpye = outputType.split('/')[1]; // e.g. "jpeg"
          // 计算压缩后的大小
          const compressedSize = this.base64Size(this.imageBase64);
          console.log("压缩后文件大小:", (compressedSize / 1024).toFixed(2), "KB");
        };
      };

      reader.readAsDataURL(file);
      event.target.value = '';
    },
    uploadImage() {
      let that = this
      if (!that.imageBase64) {
        that.$utils.alertText(that.$t('uploadTips'), 100);
        return;
      }
      let data = {
        image: {
          type: that.imageTpye,
          content: that.imageBase64
        },
        id: that.productId,
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/product/image2video', data, r => {
        that.$parent.loadModal(false);
        that.getHome()
        if (r.code == 0) {
          that.$refs.processDialog.showMaskFun();
          that.processMsg = r.msg
          return;
        }
        that.$parent.returnCode(r, function () {
          that.$refs.imgDialog.showMaskFun();
          that.imageShow = true
          that.detail = r.data
        });
      })
    },
    getImage() {
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = this.detail.url
      console.log(link.href)
      // link.target = '_blank'
      link.setAttribute('download', '文件名称')
      document.body.appendChild(link)
      link.click()
      window.open(this.detail.url, '_blank')

    },
    closeTmgDialog() {
      this.detail = {}
      this.$refs.imgDialog.closeMask();
    },
    closeProcessDialog() {
      this.processMsg = ""
      this.$refs.processDialog.closeMask();
    },
    goPurchaseChances() {
      this.$router.push({path: '/purchaseChances'})
    },
    // 辅助方法：计算 base64 图片大小
    base64Size(base64) {
      let str = base64.split(',')[1]; // 去掉前缀 data:image/jpeg;base64,
      let eqIndex = str.indexOf('=');
      if (eqIndex > 0) {
        str = str.substring(0, eqIndex); // 去掉填充字符
      }
      let length = str.length;
      return length * 3 / 4; // 得到字节数
    }
  }
}
</script>
<style scoped>
.video-player-wrap {
  width: 100%;
  max-width: 100%;
  border-radius: 0.16rem;
  overflow: hidden;
  box-sizing: border-box;
}
.video-player {
  display: block;
  width: 100%;
  max-height: 50vh;
  object-fit: contain;
  background: #000;
  border-radius: 0.16rem;
}

/* 上传照片行 */
.upload-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
}

/* 生成按钮行 */
.generate-row {
  display: flex;
  justify-content: center;
}
.pick-photo-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.1rem;
  padding: 0.14rem 0.28rem;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 0.44rem;
  color: #fff;
  font-size: 0.26rem;
  cursor: pointer;
  flex-shrink: 0;
}
.pick-photo-btn .pick-photo-icon {
  width: 0.36rem;
  height: 0.36rem;
}
.hidden-input {
  display: none;
}
.thumb-preview {
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 0.1rem;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.5);
  flex-shrink: 0;
}
.thumb-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 次数行 */
.chances-row {
  display: flex;
  justify-content: space-around;
  width: 94%;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/page/shootToVideo.vue